import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Spinner from "../Spinner/Spinner";
import "./Departments.css";
import moment from "moment";

import { Collapse } from "react-collapse";
import SaleRow from "../Sales/SaleRow";
const Departments = (props) => {
  const today = moment(new Date()).format("DD/MM/YYYY");
  const thisMonth = moment(new Date()).format("MM/YYYY");

  const [Department, setDepartment] = useState([]);
  const [Employees, setEmployees] = useState([]);
  const [Sales, setSales] = useState([]);
  const [ModalShow, setModalShow] = useState(false);
  const [NewEmployeeSale, setNewEmployeeSale] = useState("");
  const [NewSaleSum, setNewSaleSum] = useState(0);
  const [CollapseOpen, setCollapseOpen] = useState(false);

  const saleModel = {
    employeeId: NewEmployeeSale,
    saleSum: NewSaleSum,
    saleCurrency: "USD",
    exchangeRate: 1,
    departmentId: "61b0eb7df303c027543b89d1",
    primaryDep: "Conversion",
    customerId: "UNASSIGNED",
    psp: "UNASSIGNED",
    comment: "None",
  };
  function newSale() {
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(saleModel),
    };

    fetch(`${props.URL}/sales`, requestOptions)
      .then((e) => e.json())
      .then((json) => {
        let arr = Sales;
        arr.push(json);
        setSales(arr);
        setEmployees([]);
        setNewSaleSum(0);

      });
  }
  useEffect(() => {
    if (props.DepartmentsData.length > 0)
      setDepartment(
        props.DepartmentsData.filter((dep) => dep._id === props.depId)[0]
      );
  }, [props.DepartmentsData]);
  useEffect(() => {
    if (props.EmployeesData.length > 0)
      setEmployees(
        props.EmployeesData.filter((emp) => emp.departmentId === Department._id)
      );
  }, [props.EmployeesData]);
  useEffect(() => {
    if (props.SalesData.length > 0)
      setSales(
        props.SalesData
          // .filter(
          //   (sale) => moment(sale.date).format("DD/MM/YYYY") == today
          // )
          .filter((sale) => sale.departmentId === Department._id)
      );
  }, [props.SalesData]);
  function empSaleSum(id) {
    let SaleSum = 0;
    Sales.length > 0 &&
      Sales.filter((sale) => moment(sale.date).format("DD/MM/YYYY") == today)
        .filter((sale) => sale.employeeId === id)
        .forEach((sale) => (SaleSum += sale.saleSum * sale.exchangeRate));
    return SaleSum;
  }
  function empSaleNum(id) {
    let length = 0;
    if (Sales.length > 0)
      length = Sales.filter(
        (sale) => moment(sale.date).format("MM/YYYY") == thisMonth
      ).filter((sale) => sale.employeeId === id).length;
    return length;
  }
  return (
    <div className="department-card">
      <div>
        <h1>Conversion Dashboard</h1>
        <h4>{today}</h4>
      </div>
      <div className="table special-table">
        <div className="thead">
          <div className="tr">
            <div className="th">Agent Name</div>
            <div className="th">Monthly FTDs</div>
            <div className="th">Daily Deposits</div>
            {/* <div className="th options">Details</div> */}
          </div>
        </div>
        <div className="tbody">
          {props.EmployeesData.length > 0 ? (
            Employees.map((emp) => {
              return (
                <>
                  <div className="tr" key={emp._id}>
                    <div className="td">
                      {emp.firstName} {emp.lastName}
                    </div>
                    <div className="td">{empSaleNum(emp._id)}</div>
                    <div className="td">
                      {Math.round(empSaleSum(emp._id)).toLocaleString()}$
                    </div>
                    {/* <div
                      className="td options"
                      onClick={() => {
                        CollapseOpen === emp._id
                          ? setCollapseOpen("")
                          : setCollapseOpen(emp._id);
                      }}
                      style={{ width: "2vw", cursor: "pointer" }}
                    >
                      {CollapseOpen === emp._id ? "-" : "+"}
                    </div> */}
                  </div>
                  {/* <div className="collapse-row">
                    <div className="td"> */}
                  {/* <Collapse isOpened={CollapseOpen === emp._id}>
                    <div className="table sales-table">
                      <div className="thead">
                        <div className="th">Date</div>
                        <div className="th">Amount</div>
                      </div>
                      <div className="tbody">
                        {Sales.filter(
                          (sale) =>
                            moment(sale.date).format("MM/YYYY") === thisMonth
                        )
                          .filter((sale) => sale.employeeId === emp._id)
                          .map((sale) => (
                            <SaleRow
                              URL={props.URL}
                              sale={sale}
                              User={props.User}
                            />
                          ))}
                      </div>
                    </div>
                  </Collapse> */}
                  {/* </td>
                  </tr> */}
                </>
              );
            })
          ) : (
            <div className="tr">
              <div className="td">
                <Spinner />
              </div>
              <div className="td">
                <Spinner />
              </div>
              <div className="td">
                <Spinner />
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <div className="actions">
        <button
          onClick={() => {
            setNewSaleSum("");
            setNewEmployeeSale("");
            setModalShow(!ModalShow);
          }}
        >
          New FTD
        </button>
      </div> */}
      <Modal
        show={ModalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">New FTD</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Fill in the details</h4>
          <div className="form">
            <select
              onChange={(e) => {
                setNewEmployeeSale(e.target.value);
              }}
            >
              <option disabled selected>
                Agent Name
              </option>
              {Employees.length > 0 &&
                Employees.map((emp) => (
                  <option value={emp._id}>
                    {emp.firstName} {emp.lastName}
                  </option>
                ))}
            </select>
            <input
              onChange={(e) => {
                setNewSaleSum(e.target.value);
              }}
              type="number"
              value={NewSaleSum > 0 ? NewSaleSum : ""}
            ></input>
          </div>
          <br />
          <Button
            disabled={NewSaleSum > 0 && NewEmployeeSale != "" ? false : true}
            size="lg"
            variant="success"
            onClick={() => {
              newSale();
              setModalShow(false);
            }}
          >
            Add FTD
          </Button>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setModalShow(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      
    </div>
  );
};

export default Departments;
